import { FunctionComponent } from "react";
import SkeletonItem from "../SkeletonItem";
import "./style.scss";

const SkeletonCollection: FunctionComponent = ({}) => {
  return (
    <div className="SkeletonCollection">
      <SkeletonItem type="image" />
      <SkeletonItem color="#ffffff" height={12} type="text" width="80%" />
      <SkeletonItem color="#ffffff" height={48} type="button" width="90%" />
    </div>
  );
};

export default SkeletonCollection;
